module.exports = __webpack_public_path__ + "static/media/IMG_3600.bf7f84b3.jpg";